export default "__VITE_ASSET__CYDu6nPz__"